export default function nl2br(str) {
    if(!(str && str.length)) return str;
    return str
        .replace(/\n/ig, '<br/>')
        .replace(/\t/ig, '&nbsp;&nbsp;&nbsp;&nbsp;');
};
